import { AttributesGridView } from '~/components/attributes/list';
import { PageContainer } from '~/components/page-container';

export function Attributes() {
	return (
		<PageContainer>
			<AttributesGridView />
		</PageContainer>
	);
}
